import { CloudUpload, RemoveCircleOutline } from "@mui/icons-material";
import { styled } from "@mui/material";
import React from "react";
import Dropzone from "react-dropzone";
import { acceptedFileTypes } from "./../utils/constants";

const StyledDropzone = styled("div")({
    borderRadius: "3px",
    border: "2px dashed #dbdbdb",
});

const StyledCloudIconSmall = styled(CloudUpload)({
    width: "40px",
    height: "40px",
    color: "#9E9E9E",
});

const StyledErrorIconSmall = styled(RemoveCircleOutline)({
    width: "25px",
    height: "25px",
    fill: "rgb(224, 68, 3)",
    marginRight: "10px",
});

const StyledDropzoneSmallTextWrapper = styled("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "20px",
    justifyContent: "center",
});

const StyledDropzoneUploadText = styled("div")({
    color: "rgba(0, 0, 0, 0.54)",
});

const StyledDropzoneUploadHeaderText = styled("div")({
    fontWeight: "600",
    color: "rgba(0, 0, 0, 0.75)",
});

const StyledDropzoneTextContainer = styled("div")({
    marginLeft: "20px",
});

const DropzoneComponent = (props) => {
    const { disableUploads, handleAddDocuments, type } = props;
    return (
        <StyledDropzone>
            <Dropzone
                accept={acceptedFileTypes}
                disabled={disableUploads}
                onDrop={(accepted, rejected) => {
                    handleAddDocuments(accepted, rejected, type);
                }}
            >
                {({ getRootProps, getInputProps }) =>
                    !disableUploads ? (
                        <StyledDropzoneSmallTextWrapper {...getRootProps()}>
                            <input {...getInputProps()} />
                            <StyledCloudIconSmall />
                            <StyledDropzoneTextContainer>
                                <StyledDropzoneUploadHeaderText>
                                    Drop files on page to attach or browse here
                                </StyledDropzoneUploadHeaderText>
                                <StyledDropzoneUploadText>
                                    (.csv, .doc, .docx, .jpg, .jpeg, .msg, .pdf, .png, .xls, and .xlsx files only)
                                </StyledDropzoneUploadText>
                            </StyledDropzoneTextContainer>
                        </StyledDropzoneSmallTextWrapper>
                    ) : (
                        <React.Fragment>
                            <StyledDropzoneSmallTextWrapper>
                                <StyledErrorIconSmall />
                                <StyledDropzoneUploadText>
                                    Document upload access is restricted for your user role in this status
                                </StyledDropzoneUploadText>
                            </StyledDropzoneSmallTextWrapper>
                        </React.Fragment>
                    )
                }
            </Dropzone>
        </StyledDropzone>
    );
};

export default DropzoneComponent;
